import styled from '@emotion/styled';
import Dialog from '@gumtree/ui-library/src/dialog/dialog';
import HintText from '@gumtree/ui-library/src/hint-text/hint-text';
import {
    boxSizes,
    breakpoints,
    colors,
    fontSizes,
    gutterSizes,
    mediaQuery,
} from '@gumtree/ui-library/src/base/theme';

export const StyledModal = styled(Dialog)`
    max-width: 420px;
    border-radius: ${boxSizes.borderRadius8};
    padding: ${gutterSizes.xlarge};

    .dialog-title {
        font-size: ${fontSizes.pgLarge};
    }

    ${mediaQuery.until(breakpoints.small)} {
        padding: ${gutterSizes.large};

        .dialog-title {
            font-size: ${fontSizes.xlarge};
        }
    }
`;

export const InfoList = styled.ul`
    background: ${colors.surface};
    border-radius: ${boxSizes.borderRadius8};
    display: flex;
    flex-direction: column;
    gap: ${gutterSizes.large20};
    padding: ${gutterSizes.large20} ${gutterSizes.large};
    font-size: ${fontSizes.base};
`;

export const InfoListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info-value {
        font-weight: 600;
    }
`;

export const StyledHintText = styled(HintText)`
    color: ${colors.bark80} !important;
    margin-bottom: 0;
`;
